import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Checkbox } from 'semantic-ui-react';

import { Box, Flex } from 'Components/Base';
import RichTextEditor from 'Components/RichTextEditor';
import withFormsy from 'Components/Form/withFormsy';

const EditorBox = styled(Box)`
  flex: 1;
  & .text-editor {
    width: 100%;
  }
`;

const RichTextEditorBox = styled(RichTextEditor)`
  > .RichTextEditor__root___2QXK- {
    max-width: 60vw;
  }
  & .public-DraftEditor-content {
    min-height: 20vh;
  }
`;

const defaultValue = { type: RichTextEditor.contentFormat.HTML, content: null };

/**
 * @param {string} initValue - detail | ex. {content: '<p>HTML CONTENT</p>', type: 'HTML'}
 */
const DescriptionInput = ({ value: initValue, checkboxList, onChange, readOnly }) => {
  const [content, setContent] = useState(
    initValue && initValue.type === defaultValue.type ? initValue.content : defaultValue.content
  );
  const [type, setType] = useState(defaultValue.type);
  const updateValue = useCallback(() => {
    onChange({}, { value: { type, content } });
  }, [type, content, onChange]);

  useEffect(() => {
    updateValue();
  }, [updateValue]);

  return (
    <Box>
      <EditorBox>
        <RichTextEditorBox
          value={content}
          onChange={(value) => setContent(value)}
          contentFormat={type}
          returnValueAsString
          readOnly={readOnly}
        />
      </EditorBox>
      <Box mt={3}>
        {checkboxList.map(({ label, name, isChecked, onChange, tooltip, show }, idx) =>
          show ? (
            <Flex key={idx} mt={3}>
              <Checkbox
                name={name}
                label={label}
                readOnly={readOnly}
                checked={isChecked}
                onChange={onChange}
              />
              {tooltip}
            </Flex>
          ) : null
        )}
      </Box>
    </Box>
  );
};

DescriptionInput.propTypes = {
  value: PropTypes.object,
  checkboxList: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
};

export default withFormsy(DescriptionInput);
